import React, { Component } from "react";
import PdfStats from "./PdfStats";
export class DashBoardStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animateIn: false
    };
  }
  render() {
    return (
      <div className="dashboard-stats">
        <h1>English Motets stats:</h1>
        <PdfStats />
      </div>
    );
  }
}

export default DashBoardStats;



// WEBPACK FOOTER //
// ./src/components/DashboardStats.js